"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationsChannel = void 0;
const topic_1 = require("../../topic");
const COMMUNICATIONS_CHANNEL = 'communications';
class CommunicationsChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = COMMUNICATIONS_CHANNEL;
        this.topics = {
            InAppMessage: new topic_1.Topic('InAppMessage', this.channel, this._logger),
            HostedClientMessage: new topic_1.Topic('HostedClientMessage', this.channel, this._logger),
        };
    }
}
exports.CommunicationsChannel = CommunicationsChannel;
//# sourceMappingURL=communications.channel.js.map